import { useGetSeverityGrid } from "@/entities/severity-grid/severity-grid.query";
import { useContextInterventionAsset } from "@/features/Interventions/Details/InterventionContext";

export const useSeverityGridFromInterventionAsset = () => {
  const { asset_type_id, severity_grid_id } = useContextInterventionAsset();
  const { severityGrid, ...resultQuery } = useGetSeverityGrid({
    assetTypeId: asset_type_id,
    severityGridId: severity_grid_id,
  });

  return {
    ...resultQuery,
    severityGrid: severityGrid?.grid,
    isGridDefinedForAsset: !!severityGrid,
  };
};
